export default __webpack_public_path__ + "static/media/julian_laptop.0739477e.svg";